import { render, staticRenderFns } from "./BuyTicketListView.vue?vue&type=template&id=6b7b6913&scoped=true"
import script from "./BuyTicketListView.vue?vue&type=script&lang=js"
export * from "./BuyTicketListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b6913",
  null
  
)

export default component.exports